import { render, staticRenderFns } from "./AlertSrTable.vue?vue&type=template&id=432f68bb&scoped=true&"
import script from "./AlertSrTable.vue?vue&type=script&lang=js&"
export * from "./AlertSrTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertSrTable.vue?vue&type=style&index=0&id=432f68bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f68bb",
  null
  
)

export default component.exports